<template>
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 0C1.791 0 0 1.791 0 4C0 6.209 1.791 8 4 8C6.209 8 8 6.209 8 4C8 1.791 6.209 0 4 0ZM4.33333 6H3.66667V3.66667H4.33333V6ZM4 2.83333C3.724 2.83333 3.5 2.60933 3.5 2.33333C3.5 2.05733 3.724 1.83333 4 1.83333C4.276 1.83333 4.5 2.05733 4.5 2.33333C4.5 2.60933 4.276 2.83333 4 2.83333Z"
            fill="black"
        />
    </svg>
</template>
